<div class="card">

  <div class="card-header">
    {{ 'USER_AUTH_METHODS_TABLE_HEADER' | translate }}

    <div class="card-actions">
    </div><!-- /.card-actions -->
  </div>

  <div class="card-body">
    <table class="table table-striped table-bordered">
      <thead>
      <tr>
        <th class="table-sorter-header responsive-table-column">
          <app-table-sorter-no-op [text]="'USER_AUTH_METHODS_METHOD' | translate"></app-table-sorter-no-op>
        </th>
        <th class="table-sorter-header responsive-table-column">
          <app-table-sorter-no-op [text]="'USER_AUTH_METHODS_AVAILABLE' | translate"></app-table-sorter-no-op>
        </th>
        <th class="table-sorter-header responsive-table-column">
          <app-table-sorter-no-op [text]="'USER_AUTH_METHODS_ENABLED' | translate"></app-table-sorter-no-op>
        </th>
        <th class="table-sorter-header w-table-actions-single" *ngIf="!readonly">
          <app-table-sorter-no-op [text]="'COMMON_TABLE_HEADER_ACTIONS' | translate"></app-table-sorter-no-op>
        </th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let method of methods">
        <td class="responsive-table-column">{{ method.userProfileTypeObject.stringKey | translate }}</td>
        <td class="responsive-table-column">
          <app-animated-checkbox [selected]="method.available" [readonly]="true"
                                 class="mr-1 col-form-label align-middle"></app-animated-checkbox>
        </td>
        <td class="responsive-table-column">
          <app-animated-checkbox [selected]="method.enabled" [readonly]="true"
                                 class="mr-1 col-form-label align-middle"></app-animated-checkbox>
        </td>
        <td class="w-table-actions-single">
          <a href="#" onclick="return false"
             *ngIf="method.available && method.enabled && !readonly && !cannotDisable"
             (click)="setDisabled(method, true)" class="btn-setting table-header-action-button-disable"
             title="{{'COMMON_BUTTON_DISABLE' | translate}}">
            <i class="icomoon icons-table-item icomoon-disable"></i>
          </a>

          <a href="#" onclick="return false"
             *ngIf="method.available && !method.enabled && !readonly"
             (click)="setDisabled(method, false)" class="btn-setting table-header-action-button-enable"
             title="{{'COMMON_BUTTON_ENABLE' | translate}}">
            <i class="icomoon icons-table-item icomoon-enable"></i>
          </a>
        </td>
      </tr>
      </tbody>
      <tfoot>
      <tr>
        <th class="table-sorter-header long">
          <app-table-sorter-no-op [text]="'USER_AUTH_METHODS_METHOD' | translate"></app-table-sorter-no-op>
        </th>
        <th class="table-sorter-header w-20">
          <app-table-sorter-no-op [text]="'USER_AUTH_METHODS_AVAILABLE' | translate"></app-table-sorter-no-op>
        </th>
        <th class="table-sorter-header w-20">
          <app-table-sorter-no-op [text]="'USER_AUTH_METHODS_ENABLED' | translate"></app-table-sorter-no-op>
        </th>
        <th class="table-sorter-header w-table-actions-single" *ngIf="!readonly">
          <app-table-sorter-no-op [text]="'COMMON_TABLE_HEADER_ACTIONS' | translate"></app-table-sorter-no-op>
        </th>
      </tr>
      </tfoot>
    </table>

  </div><!-- /.card-body -->

</div><!-- /.card -->
